import { type Language, getTranslation } from "../lib/i18n";

export type FormType = 'learn-more' | 'get-in-touch' | 'form' | 'article';

export interface FormData {
    name: string;
    email: string;
    jobTitle: string;
    phoneNumber: string;
    companyName: string;
    companySize: string;
    message: string;
}

const WEBHOOK_PROXY_URL = '/api/zoho-webhook';

export async function sendFormDataToZoho(
    { name, email, jobTitle, phoneNumber, companyName, companySize, message }: FormData,
    formType: FormType = 'get-in-touch',
    lang: Language = "en"
): Promise<{ success: boolean; error?: string }> {
    try {
        const translation = getTranslation(lang);
        
        let form_name: string;
        switch (formType) {
            case 'learn-more':
                form_name = translation.bookDemo;
                break;
            case 'get-in-touch':
                form_name = translation.getInTouch;
                break;
            case 'form':
                form_name = 'Form';
                break;
            case 'article':
                form_name = translation.articalModalTitle || 'Article Form';
                break;
            default:
                form_name = translation.getInTouch;
        }

        const requestBody = {
            name,
            job_title: jobTitle,
            email,
            phone: phoneNumber,
            company: companyName,
            company_name: companyName,
            company_size: companySize,
            form_name,
            message,
            source: 'NowPay Egypt Website',
            form_source: 'Website Contact Form',
        };

        const response = await fetch(WEBHOOK_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            throw new Error(`Zoho webhook failed with status ${response.status}: ${await response.text()}`);
        }

        return { success: true };
    } catch (error: any) {
        console.error('Error sending data to Zoho CRM:', error);
        return { success: false, error: error.message || 'Failed to send to Zoho CRM' };
    }
}